export const faq = {

}


// WEBPACK FOOTER //
// ./src/common/constants/faq.js